module.exports = __webpack_public_path__ + "static/media/background04.3ee9f2de.jpg";